import { useState, useCallback, memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { generateRandomUid } from '../TournamentParticipants/externalFunctions'
import { addParticipant } from '../../redux/tournamentParticipantsService/tournamentParticipantsSlice'
import { Input } from '../Input/Input'
import { Button } from '../Button/Button'
import { ReactComponent as ExitBlueIcon } from '../../icon/exit-blue.svg'
import { ReactComponent as AccountIcon } from '../../icon/account.svg'

const DoublesearchForPlayersComponent = ({
	search,
	searchPlayersList,
	participants,
	involvedPlayers
}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [firstPlayer, setFirstPlayer] = useState('')
	const [secondPlayer, setSecondPlayer] = useState('')
	const [chosenSearchInput, setChosenSearchInput] = useState('')
	const [chosenPlayers, setChosenPlayers] = useState({})
	const [limitPlayer, setLimitPlayer] = useState(0)

	const handleInputOfDoublePopup = useCallback((value) => {
		setChosenSearchInput(value)
		search('')
	}, [search])

	const handleFirstInput = useCallback((value) => {
		setFirstPlayer(value)
		search(value)
	}, [search])

	const handleSecondInput = useCallback((value) => {
		setSecondPlayer(value)
		search(value)
	}, [search])

	const updateFirstPlayer = useCallback((player) => {
		setFirstPlayer(`${player?.last_name} ${player?.first_name}`)

		setChosenPlayers({
			...chosenPlayers,
			player1: {
				uid: player?.uid,
				last_name: player?.last_name,
				first_name: player?.first_name
			}
		})
	}, [chosenPlayers])

	const updateSecondPlayer = useCallback((player) => {
		setSecondPlayer(`${player?.last_name} ${player?.first_name}`)

		setChosenPlayers({
			...chosenPlayers,
			player2: {
				uid: player?.uid,
				last_name: player?.last_name,
				first_name: player?.first_name
			}
		})
	}, [chosenPlayers])

	const handlePlayerInPopupList = useCallback((player) => {
		if (chosenPlayers?.player1?.uid === player?.uid || chosenPlayers?.player2?.uid === player?.uid) {
			return
		}

		if (involvedPlayers?.includes(player?.uid)) {
			return
		}

		if (chosenSearchInput === '1' || (!firstPlayer && chosenSearchInput !== '2')) {
			updateFirstPlayer(player)
		} else {
			updateSecondPlayer(player)
		}

	}, [updateFirstPlayer, updateSecondPlayer, chosenSearchInput, firstPlayer, involvedPlayers, chosenPlayers])

	useEffect(() => {
		setLimitPlayer(participants?.length)
	}, [participants])

	const handleSaveButton = useCallback(() => {
		if (participants?.length === 8 || !firstPlayer || !secondPlayer
			|| !chosenPlayers?.player1 || !chosenPlayers?.player2) {
			return
		}

		const addingDouble = {
			uid: generateRandomUid(),
			player1: chosenPlayers?.player1,
			player2: chosenPlayers?.player2
		}

		dispatch(addParticipant(addingDouble))
		setFirstPlayer('')
		setSecondPlayer('')
		setChosenSearchInput('')
		setChosenPlayers({})
	}, [dispatch, chosenPlayers, secondPlayer, firstPlayer, participants])

	return (
		<>
			<div>
				<div className="popup__input-player--first">
					<Input
						type="search"
						autoComplete="off"
						placeholder={t('Add player')}
						value={firstPlayer}
						borderColor={chosenSearchInput === '1' && '#367BCF'}
						onChange={(e) => handleFirstInput(e.target.value)}
						onClick={() => handleInputOfDoublePopup('1')}
					/>
				</div>

				<div className="popup__input-player--second">
					<Input
						type="search"
						autoComplete="off"
						placeholder={t('Add player')}
						value={secondPlayer}
						borderColor={chosenSearchInput === '2' && '#367BCF'}
						onChange={(e) => handleSecondInput(e.target.value)}
						onClick={() => handleInputOfDoublePopup('2')}
					/>
				</div>

				<div className="popup-button__addition-doubles">
					<Button
						title={t('Save double')}
						onClick={() => handleSaveButton()}
						background={participants?.length === 8 && '#CCCCCC'}
					/>
				</div>
			</div>

			{
				searchPlayersList?.length === 0 &&
					<>
						<span
							style={{
								backgroundColor: '#CCCCCC',
								width: '100%',
								height: '1px',
								margin: '15px 0 0 0',
								display: 'block'
							}}
						></span>

						{/* <p style={{ margin: '15px 0 0 0'}}>
							В Вашем Аккаунте еще нет игроков. Выйдите из турнира <ExitBlueIcon style={{ width: '20px', height: '20px'}} /> и добавьте игроков в Вашем Аккаунте <AccountIcon style={{ width: '23px', height: '23px'}} />
						</p> */}
					</>
			}

			{
				searchPlayersList?.map((el, index) =>
					<div
						key={index}
						className="popup-search__list-item"
						style={{
							backgroundColor:
								chosenPlayers?.player1?.uid === el?.uid || chosenPlayers?.player2?.uid === el?.uid ||
									involvedPlayers.includes(el?.uid) ? 
									'#EBF4FF'
									:
									limitPlayer >= 8 ?
										'#eeeeee'
										:
										''
						}}
						onClick={() => handlePlayerInPopupList(el)}
					>
						<p className="popup-search__player-name">
							{el?.last_name} {el?.first_name} {el?.middle_name ? el?.middle_name : ''}
						</p>

						{
							involvedPlayers?.includes(el?.uid) &&
							<p className="popup-search__list-item-status">
								{t('Added')}
							</p>
						}
					</div>
				)
			}
		</>
	)
}

export const DoublesearchForPlayers = memo(DoublesearchForPlayersComponent)
